import type {
  WidgetDependenciesConstraint,
  WidgetFaultConstraint,
  WidgetGenericFault,
} from "@skbkontur/loader-builder";
import { externals } from "./private.js";
import type { ImportModuleResult, ImportParams } from "./publicApi.js";
import { importWidgetModule } from "./publicApi.js";

export type { WidgetFaultConstraint, Disposable } from "@skbkontur/loader-builder";
export type { OperationSuccess, OperationFailed, OperationResult } from "@skbkontur/operation-result";
export { isSuccess, createSuccess, isFailure, createFailure } from "@skbkontur/operation-result";
export type { WidgetApi, ImportParams, DisposeFaults, ImportFaults } from "./publicApi.js";

export type PlatformTypesConstraint = {
  ImportDependencies: WidgetDependenciesConstraint;
  JsLoaderImportsFaults: WidgetFaultConstraint;
  WidgetImportFaults: WidgetFaultConstraint;
  DisposeFaults: WidgetFaultConstraint;
  WidgetApi: object;
};

export type AddStyleRootFault = WidgetGenericFault<"style-manager">;
export type GetConnectedRootFault = WidgetGenericFault<"container-is-not-attached">;

export type ImportWidgetModule<TPlatformTypes extends PlatformTypesConstraint> = (
  importParams: ImportParams<TPlatformTypes>
) => ImportModuleResult<TPlatformTypes>;
export const createImportWidgetModule = <
  TPlatformTypes extends PlatformTypesConstraint,
>(): ImportWidgetModule<TPlatformTypes> => importWidgetModule(externals);
